import { render, staticRenderFns } from "./treatments-list-filter.vue?vue&type=template&id=00c47f7e"
import script from "./treatments-list-filter.vue?vue&type=script&lang=ts"
export * from "./treatments-list-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports